import { Badge } from '@/components/ui/badge';
import type { SupportTicketStatus } from '@/api/support';
import { cn } from '@/lib/utils';
import { getSupportStatusLabel, SUPPORT_STATUS_BADGE_VARIANTS } from '../constants';

type SupportStatusBadgeProps = {
    status: SupportTicketStatus;
    perspective?: 'user' | 'agent';
    className?: string;
    showDot?: boolean;
};

export function SupportStatusBadge({
    status,
    perspective = 'user',
    className,
    showDot = false,
}: SupportStatusBadgeProps) {
    return (
        <Badge variant={SUPPORT_STATUS_BADGE_VARIANTS[status]} className={cn('gap-1.5', className)}>
            {showDot ? <span className="h-1.5 w-1.5 rounded-full bg-current" /> : null}
            {getSupportStatusLabel(status, perspective)}
        </Badge>
    );
}
